import {Routes} from "@angular/router";
import {RolePermission} from "@menu-security";

export const CREATE = "create";

export const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        loadComponent: async () => import("./meal-plan-model-list/meal-plan-model-list.component").then(({MealPlanModelListComponent}) => MealPlanModelListComponent),
    },
    {
        path: CREATE,
        data: {permissions: [RolePermission.MealPlanModelWrite]},
        loadChildren: async () => import("./meal-plan-model-create/meal-plan-model-create.routes").then((MealPlanModelCreate) => MealPlanModelCreate.routes),
    },
    {
        path: "**",
        redirectTo: "",
    },
];
